/**
 * What the panel says after an invite (KEY-536).
 *
 * The reported bug was that the app never emailed the guest link at all — it only ever appeared on the
 * inviter's screen, while the copy promised a message. Now the server sends it, and the send can still
 * fail: a provider outage, a misconfigured environment. When it does, the invite is *not* undone (the
 * grant is committed and the link works), so the panel keeps showing the link and asks the inviter to
 * pass it on. That second branch is the whole point of this module — it's the one a future tidy-up would
 * quietly delete, so it's pinned by a test instead of living inline in JSX.
 */
export interface GuestInviteOutcome {
  headline: string;
  note: string;
  tone: "ok" | "warn";
}

/** The two facts the copy turns on: who the invite went to, and whether the email actually left. */
export interface GuestInvite {
  email: string;
  emailSent: boolean;
}

export function guestInviteOutcome({ email, emailSent }: GuestInvite): GuestInviteOutcome {
  return emailSent
    ? {
        headline: `Emailed to ${email}`,
        note: `You won’t see this link again — it only works with a code sent to that address.`,
        tone: "ok",
      }
    : {
        headline: `We couldn’t email this to ${email}`,
        note: "Copy the link and send it to them yourself — it still works, and they'll get a code when they open it.",
        tone: "warn",
      };
}
